var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "main-component", style: _vm.up }, [
    _c("div", { staticClass: "first-section", style: _vm.up }),
    _vm.last
      ? _c("div", { staticClass: "second-section" }, [
          _c(
            "div",
            { staticClass: "second-wrap" },
            [
              _c("p", { staticClass: "project-name" }, [_vm._v("项目")]),
              _vm._m(0),
              _vm._m(1),
              _vm._m(2),
              _vm._m(3),
              _c(
                "nuxt-link",
                { staticClass: "project-more", attrs: { to: "" } },
                [_vm._v("更多项目")]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.last
      ? _c(
          "div",
          { staticClass: "third-section", style: _vm.up },
          [_c("common-title", { attrs: { title: "标题", describe: "文字" } })],
          1
        )
      : _vm._e(),
    _vm.last
      ? _c(
          "div",
          { staticClass: "four-section", style: _vm.up },
          [_c("common-title", { attrs: { title: "标题", describe: "文字" } })],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "project-show right bottom" }, [
      _c("img", {
        attrs: { src: require("assets/images/leftTop.jpg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "project-show bottom" }, [
      _c("img", {
        attrs: { src: require("assets/images/leftTop.jpg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "project-show right" }, [
      _c("img", {
        attrs: { src: require("assets/images/leftTop.jpg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "project-show" }, [
      _c("img", {
        attrs: { src: require("assets/images/leftTop.jpg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c9acb1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9acb1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/indexs.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1c9acb1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/indexs.vue
// module chunks = 2